if (!customElements.get('product-modal')) {
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      this.resetPlayer();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
      );
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
      }

      if (
        activeMedia.nodeName === 'DEFERRED-MEDIA' &&
        activeMediaTemplate &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }

    resetPlayer() {
      const player = this.querySelector('iframe');
      if (player) {
        player.src = player.src.replace('autoplay=1', 'autoplay=0');
      }
    }
  }

  customElements.define('product-modal', ProductModal);
}
